<script setup>
import { onMounted, ref } from 'vue'
import lottie from 'lottie-web'
import animationData from '@/assets/animations/flow_up.json'
import ContinueButton from '../molecules/ContinueButton.vue'

const animationContainer = ref(null)

const { booksCount } = defineProps(['booksCount'])

onMounted(() => {
  const animation = lottie.loadAnimation({
    container: animationContainer.value,
    renderer: 'svg',
    autoplay: true,
    loop: false,
    animationData
  })
})
</script>

<template>
  <div class="component-container">
    <div class="component-card">
      <div class="graph">
        <div ref="animationContainer"></div>
        <div class="graph-overlay">
          <div class="start">
            <div class="btn btn-xs label-xs card">Start here</div>
            <div class="sub-h-xs">NOW</div>
          </div>
          <div class="end">
            <div class="btn btn-xs label-xs card">{{ booksCount || 28 }} Books</div>
            <div class="sub-h-xs">1 MONTH LATER</div>
          </div>
        </div>
      </div>
      <p class="heading-4 primary-color">Your personalized learning plan is prepared.</p>
      <p>We’ve crafted a self-growth plan based on your responses.</p>
    </div>
    <ContinueButton @click="$emit('cta')" />
  </div>
</template>

<style scoped>

.stores {
  display: flex;
  gap: 6px;
  justify-content: center;
}

.stores > img {
  width: 100px;
}

.component-card {
  gap: 24px;
  height: 100%;
  text-align: center;
}

.graph {
  position: relative;
}

.graph-overlay {
  position: absolute;
  display: flex;
  justify-content: space-between;
  width: 100%;
  height: 100%;
  bottom: 5px;
  left: 10px;
  align-items: flex-end;
}

.start,
.end {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
}

.start {
  height: 53%;
  color: var(--primary-base);
  margin-left: -8px;
}

.end {
  height: 95%;
  color: #f5af2a;
  width: 100px;
  margin-right: -4px;
}

.card {
  display: flex;
  justify-content: center;
  padding: 6px 8px;
}

</style>
